var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex",class:{
        'flex-row': _vm.imagePosition === 'left',
        'flex-row-reverse': _vm.imagePosition === 'right'
    }},[_c('div',{staticClass:"inline-block flex-shrink-0",class:{
            'self-end': _vm.arrowStyle === 'point-down',
            'self-center': _vm.arrowStyle === 'center'
        }},[_vm._t("image",[_c('img',{staticClass:"w-20",attrs:{"src":_vm.melsonImg}})])],2),_c('div',{staticClass:"bubble self-center border bg-white flex items-center justify-center rounded-lg flex-auto shadow",class:[
            _vm.borderClass,
            {
                'mb-2': _vm.arrowStyle === 'point-down',
                'ml-8': _vm.imagePosition === 'left',
                'mr-8': _vm.imagePosition === 'right'
            }
        ]},[_c('div',{staticClass:"w-8 h-4 bubble-point",class:[
                _vm.arrowStyle,
                {
                    'bubble-point-left': _vm.imagePosition === 'left',
                    'bubble-point-right': _vm.imagePosition === 'right'
                }
            ]},[_c('svg',{staticClass:"w-full h-full stroke-current",attrs:{"viewBox":"0 0 20 20","preserveAspectRatio":"none"}},[(_vm.arrowStyle === 'point-down')?_c('path',{attrs:{"d":"M 20 0 L 1 20 L 20 19","fill":"white"}}):_vm._e(),(_vm.arrowStyle === 'center')?_c('path',{attrs:{"d":"M 20 0 L 1 10 L 20 20","fill":"white"}}):_vm._e()])]),_c('div',{staticClass:"px-2 sm:px-4 py-2"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }